module.exports = __webpack_public_path__ + "media/Religion_Track_03.56f4798b.mp3";